/* src/components/Integrations/Content/index.js */
import { humanize } from '../../../utils/words';
import useAccessToken from '../../../utils/useAccessToken';
import useLoader from '../../../utils/useLoader';
import Api from '../../../api';
import { useEffect, useState } from 'react';

import toast from 'react-hot-toast';

// ---------------------------------------------------------------------
// Main wrapper – keeps the upload UI you already had
// ---------------------------------------------------------------------
function Content({ selectedCarrier }) {
  const { isLoading, setIsLoading } = useLoader();
  const { userData } = useAccessToken();
  const [records, setRecords] = useState([]);
  const [services, setServices] = useState([]);
  const [service, setService] = useState("commissions");

  const getRecordsData = async () => {
    setIsLoading(true);

    const response = await Api.DataService.Orgs.getOrgSiteServiceRecords(userData.orgID, selectedCarrier, service)
    if (!response.success) {
      setRecords([]);
      setIsLoading(false);
      return;
    }

    const records = response.data;

    setRecords(records || []);
    setIsLoading(false);
  }

  const getServices = async () => {
    setIsLoading(true);
    const response = await Api.DataService.Sites.getSiteServices(selectedCarrier);
    if (!response.success) {
      setIsLoading(false);
      return;
    }

    const services = response.data;
    setServices(services);
    setIsLoading(false);
  }

  useEffect(() => {
    if (selectedCarrier !== 'Select a Carrier') {
      getRecordsData();
      getServices();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCarrier, service]);

  const handleRawFileDownload = async (record) => {
    try {
      setIsLoading(true);
      const result = await Api.FirebaseStorage.Documents.download(record.bucket_path);
      setIsLoading(false);

      if (result.success) toast.success('Your file has been downloaded! Check your downloads folder.');
      else throw Error(result.error)
    } catch (error) {
      setIsLoading(false);
      toast.error('Something went wrong while downloading the file. Please try again or contact support.');
    }
  }

  const handleExcelFileDownload = async (record) => {
    try {
      setIsLoading(true);
      const match = record.bucket_path.match(/raw_file\/(.*?)\.pdf/);
      const fileName = match ? match[1] : service;
      const path = record.bucket_path.replace(
        `raw_file/${fileName}.pdf`,
        `post_processors/json_to_excel/${fileName}.xlsx`
      );
      const result = await Api.FirebaseStorage.Documents.download(path);
      setIsLoading(false);

      if (result.success) toast.success('Your file has been downloaded! Check your downloads folder.');
      else throw Error(result.error)
    } catch (error) {
      setIsLoading(false);
      toast.error('Something went wrong while downloading the file. Please try again or contact support.');
    }
  }

  return (
    <>
      <div className="service-nav">
        {services.map((serviceItem) => {
          return (
            <span 
              key={serviceItem.id} 
              className={service === serviceItem.id ? "nav-item active" : "nav-item"} 
              onClick={() => setService(serviceItem.id)}
            >
              {humanize(serviceItem.id)}
            </span>
          );
        })}
      </div>
      <br/>
      <h1>{humanize('Documents')}</h1>

      <table>
        <thead>
          <th>Record Name</th>
          <th>Credential ID</th>
          <th>Created Date</th>
          <th>Excel File</th>
          <th>Raw File</th>
        </thead>
        <tbody>
          {records.map((record, index) => (
            <tr key={index}>
              <td>{record.record_text}</td>
              <td>{record.credential_id}</td>
              <td>{record.uploaded_at ? record.uploaded_at : "N/A"}</td>
              <td>
                <button 
                  className="transparent-image-button" 
                  onClick={() => handleExcelFileDownload(record)}
                  disabled={isLoading}
                  title="Download Excel File"
                >
                  <img 
                    src="/assets/excel.png" 
                    alt="Download Excel" 
                    width="48"
                    height="48"
                  />
                </button>
              </td>
              <td>
                <button 
                  className="transparent-image-button" 
                  onClick={() => handleRawFileDownload(record)}
                  disabled={isLoading}
                  title="Download Raw File"
                >
                  <img 
                    src="/assets/pdf.png" 
                    alt="Download PDF" 
                    width="48"
                    height="48"
                  />
                </button>
              </td>
            </tr>
          ))}
          { (isLoading || records.length === 0) && (
              <tr>
                <td colSpan="5" className="no-data"><center>No Data Found</center></td>
              </tr> 
            )
          }
        </tbody>
      </table>
    </>
  );
}

export default Content;
